import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { Box, Paper } from '@mui/material';
import { makeStyles } from '@mui/styles';

import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

import { topControlsWrapper } from '../../styles/styles';

import { getPaginatedAccounts, postAccountIds } from '../../services/admin/admin-account-service';
import { searchTypes } from '../../services/search-service';
import { searchDocs } from '../../services/admin/admin-search-service';
import TlFilterList, { paginationComponents } from '../form-elements/tl-filter-list';
import { getAccount, setSelectedAccountId } from '../../services/account-service';

import { receiveSelectedAccount } from '../../redux/actions/account-actions';
import variables from '../../styles/variables';

const useStyles = makeStyles({
  topControlsWrapperStyle: {
    ...topControlsWrapper,
    '& .MuiOutlinedInput-root': {
      borderRadius: '4px',

      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#bdbdbd',
        borderWidth: '1px',
      },

      '&.Mui-focused': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: '#bdbdbd',
          borderWidth: '1px',
        },
      },

      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#bdbdbd',
        borderWidth: '1px',
      },

      '& .MuiOutlinedInput-input': {
        color: 'black',
      },
      '& .MuiIconButton-root': {
        color: '#bdbdbd',
        '&:hover': {
          color: '#bdbdbd',

          '& .MuiSvgIcon-root': {
            color: '#bdbdbd',
          },
        },
      },
    },
  },

  paginationStyle: {
    padding: '2px 0 0 0',
    margin: '10px',

    '& .paginationContent': {
      display: 'flex',

      '& .totalDocs': {
        width: '100%',
        fontWeight: '500',
        fontSize: '12px',
        padding: '6px 0 0 0',
      },

      '& .forwardBackButtons': {
        display: 'flex',

        '& .buttonSeperator': {
          width: '6px',
        },

        '& button': {
          backgroundColor: variables.white,
          border: 'none',
          borderRadius: '8px',
          width: '29px',
          minWidth: '29px',
          height: '29px',
          minHeight: '29px',

          '&:hover': {
            color: 'red',
          },

          '& .buttonIcon': {
            fontSize: '18px',
            color: variables.black,
          },
        },
      },
    },
  },

  accountSelector: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    padding: '60px 0 0 0',
    backgroundColor: '#f5f5f5',
  },

  accountList: {
    width: '545px',
  },
  accountRow: {
    display: 'flex',
    width: '100%',
  },
  accountRowRight: {
    width: '100%',
    textAlign: 'right',
    padding: '8px 0 0 0',
  },
  rightIcon: {
    fontWeight: 500,
    color: variables.black,
  },
  accountName: {
    fontWeight: 500,
    fontSize: '14px',
    color: variables.black,
  },
  accountData: {
    display: 'flex',
    fontWeight: 400,
    fontSize: '12px',
    color: variables.black,
  },
  accountType: {
    margin: '0 0 0 5px',
  },
});

const AdminAccountSelector = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const dispatchSelectedAccount = useCallback(
    (account) => {
      dispatch(receiveSelectedAccount(account));
    },
    [dispatch]
  );

  return (
    <Box className={classes.accountSelector}>
      <Box className={classes.accountList}>
        <TlFilterList
          linkTo={(e, object) => {
            e.preventDefault();
            const { _id: accountId } = object;

            getAccount(accountId).then((account) => {
              setSelectedAccountId(accountId);
              dispatchSelectedAccount(account);
              window.location.href = '/dashboard';
            });
          }}
          columns={{
            account: {
              cellJsx: (object) => {
                const accountType = object.publisherScope ? 'Publisher' : 'Advertiser';

                return (
                  <Box className={classes.accountRow}>
                    <Box>
                      <Box className={classes.accountName}>{object.name}</Box>
                      <Box className={classes.accountData}>
                        <Box>ID: {object._id},</Box>
                        <Box className={classes.accountType}>Type: {accountType}</Box>
                      </Box>
                    </Box>
                    <Box className={classes.accountRowRight}>
                      <KeyboardArrowRightIcon className={classes.rightIcon} />
                    </Box>
                  </Box>
                );
              },
            },
          }}
          paginationComponent={paginationComponents.tlForwardBack}
          paginationStyle={classes.paginationStyle}
          topControlsWrapperStyle={classes.topControlsWrapperStyle}
          listContainerComponent={Paper}
          listContainerElevation={2}
          renderHeader={false}
          fetchObjectsByIds={postAccountIds}
          fetchObjects={getPaginatedAccounts}
          searchDocs={searchDocs}
          searchType={searchTypes.account}
          objectSingularLabel="Account"
          objectPluralLabel="Accounts"
        />
      </Box>
    </Box>
  );
};

export default AdminAccountSelector;
